import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_REtoDFA_DirectMethod = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Regular expression to Deterministic Finite Automata (Direct method)"
    videos={[
      "https://www.youtube.com/embed/p5MbSZ4nBho",
    ]}
    takeaways={[
      { text: "Most probable question from this topic in both CAT1 and FAT" },
      { text: "Do some practice questions on this topic" },
    ]}
    questions={[
      "Using Direct method, convert the following Regular Expression into Deterministic Finite State Automata: (a*|ε|b*).c",
      "Convert the regular expression (a|b)*cc(d|c)* to a DFA using the direct method with syntax tree. Provide a step-by-step explanation of the process, including the construction of the syntax tree, assignment of firstpos and lastpos, computation of followpos, and the construction of the DFA states and transitions. Finally, test the DFA with the input strings \"aabccd\" and \"acdd\" to determine if they are accepted or rejected by the DFA.",
      "Construct Finite Automata and describe the language denoted by the regular expression (a|b)*a(a|b)(a|b).",
      "Find firstpos(n), lastpos(n) and followpos(i) of 0*10*",
      "Convert the regular expression (01+1)*00 (0+1)* into a DFA using the direct method. Provide a step-by-step explanation and algorithm.",
      "Construct a finite automata for the given language L = {w ∈ (0+1)* | w has no pair of consecutive zeros} and check whether the given strings w1=1011010 and w2=111001 are accepted by the finite automata or not.",
      "Convert the regular expression (a|b)*abb(a|b)* into deterministic finite automata using direct method.",
      "Convert the regular expression (0/1)*11 into a DFA using the direct method. Provide a detailed step-by-step explanation and the corresponding algorithm.",
      "Using the Direct method, convert the following Regular Expression into Deterministic Finite State Automata: a*b*a(a|b)*a#",
      "Write the regular expression for the C++ language identifier and convert it into deterministic finite automata using the direct method. Consider C++ language identifiers that start with an underscore ( _ ) or letter (L) followed by zero or more occurrences of underscore ( _ ) or letter (L) or digit (D).",
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_REtoDFA_DirectMethod;
